import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, withTypes } from 'react-final-form';
import { useHistory } from 'react-router-dom';
import { Button, Card, Typography, CircularProgress, TextField, Box, useMediaQuery, InputAdornment, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
// import { ThemeProvider } from '@material-ui/styles';
import { useTranslate } from 'react-admin';
import { useLogin, useAuthProvider } from 'ra-core';
import { lightTheme } from './themes';
import mainLogo from '../assets/logo2.png'
import emailSend from '../assets/mailsend.png'
import { red, pink } from '@material-ui/core/colors';
import classes from '*.module.css';
import colors from '../CustomizedUIs/Colors'
import CustomTextFiled from '../CustomizedUIs/CustomTextFiled'

const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles((theme:any) => ({
    conainer: {
        minHeight: '100vh',
        [theme.breakpoints.up(500)]: {
            backgroundImage: 'url(/images/hopital-bg.jpg)',
        },
    },
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
    },
    card: {
        borderRadius:10,
        margin: 'auto',
        [theme.breakpoints.up('xs')]: {
            padding: '3em 3em'
        },
        [theme.breakpoints.down('xs')]: {
            padding: '3em 1em'
        },
        backgroundColor:'white'
    },
    notchedOutline: {
        borderWidth: "1px",
        borderColor: "yellow !important"
    },
    form: {
        padding: '0 1em 1em 1em',
    },
    actions: {
        padding: '0 1em 1em 1em',
    },
    text: {
        color: 'white',
        lineHeight: '0',
        fontWeight: 'bold'
    },
    h1: {
        background: '-webkit-linear-gradient(blue, green)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
    },
    TitleConfirmEmail: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '22px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    ConstentConfirmEmail: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    btnBackLogin: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
    },
    TextLogin: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#88898c'

    }, btnSignin: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
        color: "#ffffff"
    },
    textFogot: {
        height: '13px',
        cursor: 'pointer',
        fontFamily: 'UniviaPro',
        fontSize: '10px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: ' 0.4px',
        color:theme.overrides.MuiButton.textPrimary.color,
        paddingRight: 30
    },
    textLabel: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#88898c',
    },
    textLableError: {

        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#eb5a4d !important',
    },
    textError: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        color: '#eb5a4d !important',
    },
    underlineError: {
        '&::after': {
            borderBottom: '2px solid' + '#eb5a4d !important'
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    }, input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        }, fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#88898c',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
}));

const ForgotPasswordForm = ({ error, label, disable, handleSubmit, onChangeInput, handelBackLogin }: any) => {
    const isXsmall = useMediaQuery((theme: any) => theme.breakpoints.down('xs'));
    const translate = useTranslate();
    const classes = useStyles();
    return (
        <Box>
            <Box my={3}>
                <Box my={1}>
                    <Typography className={classes.TitleConfirmEmail}>{translate('pos.auth.forgotTitle') + '?'}</Typography>
                </Box>
                <Box mt={1}>
                    <Typography className={classes.ConstentConfirmEmail}>{translate('pos.auth.title')}</Typography>
                </Box>

            </Box>
            <Box my={2}>
                <TextField
                    variant='filled'
                    error={error.isError && error.message != ""}
                    helperText={error.message}
                    autoFocus
                    id="name"
                    label={label}
                    type="email"
                    style={{ width: isXsmall ? '100%' : 400 }}
                    fullWidth
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeInput(e)}
                    FormHelperTextProps={{
                        className: classes.textError
                    }}
                    InputLabelProps={{
                        // className: classes.textLabel,
                        classes: {
                            root: classes.textLabel,
                            error: classes.textLableError
                        }
                    }}
                    InputProps={{
                        style: {
                            fontFamily: 'UniviaPro',
                            fontSize: '13px',
                            fontWeight: 'normal',
                            fontStretch: 'normal',
                            fontStyle: 'normal',
                            lineHeight: 1.85,
                            letterSpacing: ' 0.13px',
                            color: "#4f5064",
                            backgroundColor: 'white',
                            borderRadius: 0
                        }
                    }}
                />
            </Box>
            <Box>
                <Box style={{ paddingTop: 30 }} width='100%' display='flex' justifyContent='flex-end'>
                    <Typography style={{ cursor: 'pointer', marginTop: 'auto', float: 'right' }} className={classes.textFogot} color='primary' onClick={handelBackLogin}> {translate('pos.auth.back')}</Typography>
                    <Button
                        variant="contained"
                        type="submit"
                        color="primary"
                        disabled={disable}
                        onClick={handleSubmit}
                    >
                        <Typography style={{ padding: '8px' }} className={classes.btnSignin}> {translate('pos.auth.reset')}</Typography>
                    </Button>

                </Box>
            </Box>
        </Box>
    )
};

const renderInput = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    ...props
}) => {
    return (
        <TextField
            error={!!(touched && error)}
            helperText={touched && error}
            {...inputProps}
            {...props}
            color='primary'
            fullWidth
            variant='filled'
        />
    )
};



interface FormValues {
    username?: string;
    password?: string;
}

const { Form } = withTypes<FormValues>();

const Login = () => {
    const history = useHistory()
    if (localStorage.getItem('token')) {
        history.push("/dashboard")
    }
    const [error, setError] = useState({
        isError: true,
        message: ""
    });
    const [isError, setIsError] = useState(true);
    const [input, setInput] = useState("");
    const [disable, setDisable] = useState(true);
    const [openDialog, setOpenDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isSend, setIsSend] = useState(false);
    const [message, setMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const translate = useTranslate();
    const classes = useStyles();
    const login = useLogin();
    const [notification, setNotification] = useState("")
    const isXsmall = useMediaQuery((theme: any) => theme.breakpoints.down('xs'));

    const authProvider = useAuthProvider();

    const handleSubmit = (auth: FormValues) => {
        setLoading(true);
        login(auth)
            .then(
                () => {
                    history.push("/dashboard")
                })
            .catch(
                (error: Error) => {
                    setLoading(false);
                    setNotification(
                        typeof error === 'string'
                            ? error
                            : typeof error === 'undefined' || !error.message
                                ? 'ra.auth.sign_in_error'
                                : translate('pos.auth.errorLogin')
                    );
                }
            );
    };


    const preventDefault = () => {
        setOpenDialog(true)
    }

    const handleSendMail = () => {
        authProvider
            .forgotPassword(input)
            .then((response: any) => {
                if (response.success) {
                    setIsSend(true);
                }

                else if (response.message === "email not exist")
                    setMessage(translate('pos.auth.doesNotExist'));
            });
    }

    const onChangeEmailForgot = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput(e.target.value)
        if (e.target.value == "") {
            setError({
                isError: true,
                message: translate('ra.validation.required')
            })
            setDisable(true)
        }
        else if (/[ `!@#$%^&*()+\-=\[\]{};':"\\|,.<>\/?~]/.test(e.target.value)) {
            if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e.target.value)) {
                setError({
                    isError: true,
                    message: translate('pos.auth.emailIncorrect')
                })
                setDisable(true)
            }
            else {
                setError({
                    isError: false,
                    message: ""
                })
                setDisable(false)
            }
        }
        else {
            setError({
                isError: false,
                message: ""
            })
            setDisable(false)
        }
    }
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const validate = (values: FormValues) => {
        const errors: FormValues = {};
        if (!values.username) {
            errors.username = translate('ra.validation.required');
        }
        else if (/[ `!@#$%^&*()+\-=\[\]{};':"\\|,.<>\/?~]/.test(values.username)) {
            if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(values.username))
                errors.username = translate('pos.auth.emailIncorrect');
        }
        else if (values.username.length > 50) {
            errors.username = translate('pos.auth.stringLengthMax');
        }
        if (!values.password) {
            errors.password = translate('ra.validation.required');
        }
        setIsError(errors.password || errors.username ? true : false)
        return errors;
    };


    const handelBackLogin = () => {
        setOpenDialog(false)
        setMessage("")
        setNotification("")
    }


    return (
        <div className={classes.conainer}>
            <div className={classes.main}>
                {
                    openDialog ? (
                        <Box className={classes.card}>
                            <Box justifyContent='center'>
                                <Box width='100%' textAlign='center'>
                                    <img src={mainLogo} width='206px' height='48px' />
                                </Box>
                                {
                                    isSend ? (
                                        <Box width={400} textAlign='center'>
                                            <Box display='flex' justifyContent='center' width='100%' mt={2}>
                                                <img src={emailSend} width="230" height="230" />
                                            </Box>
                                            <Typography style={{ paddingBottom: '8px' }} className={classes.TitleConfirmEmail}>{translate('pos.auth.confirmEmail')}</Typography>
                                            <Typography className={classes.ConstentConfirmEmail}>{translate('pos.auth.confirmEmailConstent')}</Typography>
                                            <Button
                                                color='primary'
                                                size='large'
                                                onClick={() => {
                                                    handelBackLogin()
                                                    setIsSend(false)

                                                }}
                                                style={{ marginTop: '16px' }} className={classes.btnBackLogin}>{translate('pos.auth.backtologin')}</Button>

                                        </Box>
                                    ) : (
                                            <Box>
                                                {
                                                    message != "" && (
                                                        <Box borderRadius='6px' my={1} width={isXsmall ? 300 : 400} bgcolor={bgColorError} py={1}>
                                                            <Typography className={classes.ConstentConfirmEmail} style={{ color: textColorError, margin: '1em' }}>{message}</Typography>
                                                        </Box>
                                                    )
                                                }
                                                <ForgotPasswordForm handleSubmit={handleSendMail}
                                                    onChangeInput={onChangeEmailForgot}
                                                    handelBackLogin={handelBackLogin}
                                                    error={error}
                                                    disable={disable}
                                                    label={translate('pos.auth.enterEmail')} />
                                            </Box>
                                        )
                                }
                            </Box>
                        </Box>
                    ) : (

                            <Form
                                onSubmit={handleSubmit}
                                validate={validate}
                                render={({ handleSubmit }) => (

                                    <form onSubmit={handleSubmit} noValidate>
                                        <Box>
                                            <Box className={classes.card}>
                                                <Box justifyContent='center'>
                                                    <Box width='100%' textAlign='center'>
                                                        <img src={mainLogo} width='206px' height='48px' />
                                                    </Box>
                                                    {

                                                        <Box>
                                                            <Box mt={3.7} mb={1.8}>
                                                                {
                                                                    notification != "" &&
                                                                    (
                                                                        <Box borderRadius='6px' my={1} width={isXsmall ? 300 : 400} bgcolor={bgColorError} py={1}>
                                                                            <Typography className={classes.ConstentConfirmEmail} style={{ color: textColorError, margin: '1em' }}>{notification}</Typography>
                                                                        </Box>
                                                                    )
                                                                }

                                                                <Typography className={classes.TitleConfirmEmail} >{translate('pos.auth.signIn')}</Typography>
                                                            </Box>
                                                            <Box>
                                                                <Field
                                                                    autoFocus
                                                                    name="username"
                                                                    // @ts-ignore
                                                                    component={renderInput}
                                                                    label={translate('pos.auth.username')}
                                                                    disabled={loading}
                                                                    style={{ width: isXsmall ? 300 : 400 }}
                                                                    FormHelperTextProps={{
                                                                        className: classes.textError
                                                                    }}
                                                                    InputLabelProps={{
                                                                        // className: classes.textLabel,
                                                                        classes: {
                                                                            root: classes.textLabel,
                                                                            error: classes.textLableError
                                                                        }
                                                                    }}
                                                                    InputProps={{
                                                                        style: {
                                                                            fontFamily: 'UniviaPro',
                                                                            fontSize: '13px',
                                                                            fontWeight: 'normal',
                                                                            fontStretch: 'normal',
                                                                            fontStyle: 'normal',
                                                                            lineHeight: 1.85,
                                                                            letterSpacing: ' 0.13px',
                                                                            color: "#4f5064",
                                                                            backgroundColor: 'white',
                                                                            borderRadius: 0
                                                                        }
                                                                    }}

                                                                />
                                                            </Box>
                                                            <Box mt={4.5} mb={2.6}>
                                                                <Field
                                                                    name="password"
                                                                    // @ts-ignore
                                                                    component={renderInput}
                                                                    label={translate('pos.auth.password')}
                                                                    style={{ width: isXsmall ? 300 : 400 }}
                                                                    disabled={loading}
                                                                    type={showPassword ? 'text' : 'password'}
                                                                    FormHelperTextProps={{
                                                                        className: classes.textError
                                                                    }}
                                                                    InputLabelProps={{
                                                                        // className: classes.textLabel,
                                                                        classes: {
                                                                            root: classes.textLabel,
                                                                            error: classes.textLableError
                                                                        }
                                                                    }}
                                                                    InputProps={{
                                                                        endAdornment:
                                                                            <InputAdornment position="end">
                                                                                {
                                                                                    !isError ? (
                                                                                        <IconButton
                                                                                            size='small'
                                                                                            aria-label="toggle password visibility"
                                                                                            onClick={handleClickShowPassword}
                                                                                            onMouseDown={handleMouseDownPassword}
                                                                                        >
                                                                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                                                                        </IconButton>
                                                                                    ) : <div></div>
                                                                                }

                                                                            </InputAdornment>,
                                                                        style: {
                                                                            fontFamily: 'UniviaPro',
                                                                            fontSize: '13px',
                                                                            fontWeight: 'normal',
                                                                            fontStretch: 'normal',
                                                                            fontStyle: 'normal',
                                                                            lineHeight: 1.85,
                                                                            letterSpacing: ' 0.13px',
                                                                            color: "#4f5064",
                                                                            borderRadius: 0,
                                                                            backgroundColor: 'white',
                                                                        },
                                                                    }}

                                                                />
                                                            </Box>
                                                            <Box width='100%' display='flex' justifyContent='flex-end' style={{ paddingBottom: 43 }}>
                                                                <Typography style={{ marginRight: 'auto', marginTop: 'auto' }} className={classes.textFogot} onClick={preventDefault}>{translate('pos.auth.forgot')}</Typography>
                                                                <Button
                                                                    variant="contained"
                                                                    style={{ width: '96px', height: '36px' }}
                                                                    type="submit"
                                                                    size='large'
                                                                    color="primary"
                                                                    disabled={loading || isError}
                                                                >
                                                                    {loading ? (
                                                                        <CircularProgress
                                                                            size={20}
                                                                            thickness={2}
                                                                            color='inherit'
                                                                        />
                                                                    ) :
                                                                        <Typography className={classes.btnSignin}>{translate('pos.auth.signIn')}</Typography>
                                                                    }

                                                                </Button>
                                                            </Box>
                                                        </Box>
                                                    }

                                                </Box>
                                            </Box>

                                        </Box>
                                    </form>
                                )}
                            />
                        )
                }


            </div>
        </div>
    );
};

Login.propTypes = {
    authProvider: PropTypes.func,
    previousRoute: PropTypes.string,
};

// We need to put the ThemeProvider decoration in another component
// Because otherwise the useStyles() hook used in Login won't get
// the right theme
const LoginWithTheme = (props: any) => (
    <ThemeProvider theme={createMuiTheme(lightTheme)}>
        <Login {...props} />
    </ThemeProvider>
);

export default LoginWithTheme;
